module.exports = __webpack_public_path__ + "nc_static/media/sw-ready-to-install.dc8dfb31.svg";